/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSegAllocControl.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/settlement/seg-alloc-control";

export class AutogenModelSegAllocControl<RowType extends ModelRow> extends Endpoint<RowType, RowSegAllocControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowSegAllocControl extends ModelRow<RowSegAllocControlFields> {
	constructor(values?: Partial<RowSegAllocControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowSegAllocControlFields {
	basis: string;
	company_id: string;
	dedicated_gl_segment: number;
	driver_gl_segment: number;
	edi_seg_alloc_code: string;
	id: number;
	is_active: string;
	ltl_terminal_gl_segment: number;
	mb_gl_segment: number;
	move_gl_segment: number;
	occurrence: string;
	office_gl_segment: number;
	payee_gl_segment: number;
	pickup_terminal_percentage: number;
	revenue_method: string;
	settlement_method: string;
	tractor_gl_segment: number;
	tw_gl_segment: number;
	tw_method: string;
	validate_account: string;
	via_terminal_basis: string;
	via_terminal_rate: number;
}

